import clsx from 'clsx';
import React, {FC} from 'react';

interface PageShellProps {
  /** 页面整体底色：white（默认）或 muted（slate-50） */
  bg?: 'muted' | 'white';
}

/**
 * v3 页面壳：所有改版页面的根容器。
 *
 * 两处约定（见 CLAUDE.md「v3 样式体系」）：
 * - 必须外包一层纯 .v3-scope 容器——工具类编译为 `.v3-scope .xxx` 后代选择器，
 *   带其他类名的根元素自身不吃工具类；
 * - fixed 导航的顶距避让由 Layout 注入的 .v3-page-offset 提供（80px/64px），
 *   这里勿再叠加 pt，否则会出现双份顶距。
 */
const PageShell: FC<PageShellProps> = ({bg = 'white', children}) => (
  <div className="v3-scope">
    <div className={clsx(bg === 'muted' ? 'bg-slate-50' : 'bg-white')}>{children}</div>
  </div>
);

export default PageShell;
